import React, { useEffect, useMemo, useRef, useState,useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Grid2X2, List, Search, SlidersHorizontal } from 'lucide-react';
import '../css/menu.css';
import '../css/SyrveMenu.css';
import {Swiper, SwiperSlide} from "swiper/react";
import {Pagination} from "swiper/modules";
import ModifierModal from "./ModifierModal";
import copacabana1 from "../img/copa/1.jpg";
import copacabana2 from "../img/copa/2.jpg";
import copacabana3 from "../img/copa/3.jpg";
import copacabana4 from "../img/copa/4.jpg";
import copacabana5 from "../img/copa/5.jpg";
import copacabana6 from "../img/copa/6.jpg";
import copacabana7 from "../img/copa/7.jpg";
import { LocalizationContext } from '../localization/LocalizationContext';
import { smartTranslateIngredients } from '../localization/foodTranslations';
import { parseMultiLanguageDescription } from '../utils/multiLanguageParser';
import menuCacheService from '../services/MenuCacheService';
import aroma1 from "../img/Aromi/3.jpg";
import aroma2 from "../img/Aromi/5.jpg";
import aroma3 from "../img/Aromi/4.jpg";
import aroma4 from "../img/Aromi/2.jpg";
import aroma5 from "../img/Aromi/1.jpg";
import aroma6 from "../img/Aromi/7.jpg";
import aroma7 from "../img/Aromi/6.jpg";
import aroma8 from "../img/Aromi/1.jpg";
import aroma9 from "../img/Aromi/9.jpg";
import aroma10 from "../img/Aromi/10.jpg";

import symp1 from "../img/Simposium/2.jpg";
import symp2 from "../img/Simposium/1.jpg";
import symp3 from "../img/Simposium/3.jpg";
import symp4 from "../img/Simposium/5.jpg";
import symp5 from "../img/Simposium/6.jpg";
import symp6 from "../img/Simposium/7.jpg";
import symp7 from "../img/Simposium/8.jpg";
import symp8 from "../img/Simposium/9.jpg";
import symp9 from "../img/Simposium/13.jpg";
import symp10 from "../img/Simposium/14.jpg";

import posh1 from "../img/POSH_NOSH/1.jpg";
import posh2 from "../img/POSH_NOSH/2.jpg";
import posh3 from "../img/POSH_NOSH/3.jpg";
import posh4 from "../img/POSH_NOSH/4.jpg";
import posh5 from "../img/POSH_NOSH/5.jpg";

import nadimi1 from "../img/Nadimi/1.jpg";
import nadimi2 from "../img/Nadimi/3.jpg";
import nadimi3 from "../img/Nadimi/2.jpg";
import nadimi4 from "../img/Nadimi/4.jpg";

import cave1 from "../img/cave.jpg";
import ProductDetail from "./ProductDetail";
import { getPOSConfig } from "../config/posConfig";
import { API_ENDPOINTS, API_PROXY_BASE } from "../config/api";
import { getOrderMode, isDeliveryMode, setOrderMode, ORDER_MODES, ORDER_MODE_CHANGE_EVENT } from '../utils/orderMode';
import { RESTAURANT_META } from '../config/restaurantMeta';

const safeFetchJson = async (res) => {
    if (!res.ok) {
        const text = await res.text();
        throw new Error(`Server error ${res.status}: ${text.substring(0, 100)}`);
    }
    return res.json();
};

const isEuropeSquareDomain = () => {
    const hostname = window.location.hostname;
    return hostname === 'europesquare.ge' ||
           hostname === 'www.europesquare.ge';
};

const isPoshnoshCompany = (companyName) => {
    const normalized = String(companyName || '').toLowerCase().replace(/\s+/g, '');
    return normalized === 'poshnosh' || normalized === 'poshnoshs';
};

const reorderPoshnoshGroups = (groups, companyName) => {
    if (!isPoshnoshCompany(companyName)) return groups;

    const ordered = [...groups];
    const isBurgerCategory = (group) => String(group?.name || '').toLowerCase().includes('burger');
    const isShawarmaCategory = (group) => String(group?.name || '').toLowerCase().includes('shawarm');
    const isBurritoCategory = (group) => {
        const name = String(group?.name || '').toLowerCase();
        return name.includes('burrito')
            || name.includes('tex mex')
            || group?.items?.some((item) => String(item?.name || '').toLowerCase().includes('burrito'));
    };

    const burgerIndex = ordered.findIndex(isBurgerCategory);
    if (burgerIndex > -1) {
        const [burgerGroup] = ordered.splice(burgerIndex, 1);
        ordered.unshift(burgerGroup);
    }

    const shawarmaIndex = ordered.findIndex(isShawarmaCategory);
    if (shawarmaIndex > -1) {
        const [shawarmaGroup] = ordered.splice(shawarmaIndex, 1);
        const burritoIndex = ordered.findIndex(isBurritoCategory);
        ordered.splice(burritoIndex > -1 ? burritoIndex + 1 : Math.min(9, ordered.length), 0, shawarmaGroup);
    }

    return ordered;
};

const PREFERRED_MENU_NAMES = ['aromiitaliani'];

const sortMenusByPreferredOrder = (menus = []) => {
    return [...menus].sort((a, b) => {
        const aIndex = PREFERRED_MENU_NAMES.indexOf(String(a?.name || '').toLowerCase());
        const bIndex = PREFERRED_MENU_NAMES.indexOf(String(b?.name || '').toLowerCase());

        if (aIndex === -1 && bIndex === -1) return 0;
        if (aIndex === -1) return 1;
        if (bIndex === -1) return -1;
        return aIndex - bIndex;
    });
};

const COMING_SOON_MENUS = Object.entries(RESTAURANT_META)
    .filter(([, meta]) => meta.comingSoon)
    .map(([key, meta]) => ({
        id: `coming-soon-${key}`,
        name: meta.name,
        bg: meta.bg,
        comingSoon: true,
    }));


const SyrveMenu = ({handleXBarItemChange}) => {
    const { company } = useParams();
    const navigate = useNavigate();
    const [token, setToken] = useState('');
    const [organizations, setOrganizations] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [groups, setGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [products, setProducts] = useState([]);
    const [groupProducts, setGroupProducts] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(null);
    const [cart, setCart] = useState({});
    const [productToModify, setProductToModify] = useState(null);
    const [fdOnlyModifierIds, setFdOnlyModifierIds] = useState(new Set());
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantities, setQuantities] = useState({});
    const [cartOpen, setCartOpen] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [description, setDescription] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [posConfig, setPosConfig] = useState(null);
    const [orderMode, setOrderModeState] = useState(getOrderMode());
    const [menuViewMode, setMenuViewMode] = useState('grid');
    const categorySectionRefs = useRef({});
    const categoryButtonRefs = useRef({});

    const isEuropeSquare = isEuropeSquareDomain();
    const canOrder = orderMode === ORDER_MODES.DELIVERY && !isEuropeSquare;

    const handleSwitchToDelivery = () => {
        setOrderMode(ORDER_MODES.DELIVERY);
        navigate('/delivery');
    };

    useEffect(() => {
        const handleOrderModeChange = (event) => {
            setOrderModeState(event.detail || getOrderMode());
        };

        window.addEventListener(ORDER_MODE_CHANGE_EVENT, handleOrderModeChange);
        window.addEventListener('storage', handleOrderModeChange);

        return () => {
            window.removeEventListener(ORDER_MODE_CHANGE_EVENT, handleOrderModeChange);
            window.removeEventListener('storage', handleOrderModeChange);
        };
    }, []);

    // Получение организаций
    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                setLoading(true);

                const tokenCacheKey = menuCacheService.generateCacheKey('token', 'access');
                const tokenData = await menuCacheService.getWithCache(
                    tokenCacheKey,
                    async () => {
                        const tokenRes = await fetch(`${API_PROXY_BASE}/access_token`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                        });
                        return await tokenRes.json();
                    },
                    'token'
                );
                setToken(tokenData.token);

                const orgCacheKey = menuCacheService.generateCacheKey('organizations');
                const orgData = await menuCacheService.getWithCache(
                    orgCacheKey,
                    async () => {
                        const orgRes = await fetch(`${API_PROXY_BASE}/organizations`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${tokenData.token}`,
                            },
                            body: JSON.stringify({
                                organizationIds: [],
                                returnAdditionsInfo: true,
                                includeDisabled: false,
                            }),
                        });
                        return await orgRes.json();
                    },
                    'organizations'
                );
                const selected = orgData.organizations[0];
                if (!selected) return;
                setSelectedOrg(selected);

                const menuListCacheKey = menuCacheService.generateCacheKey('menuList', selected.id);
                const menusData = await menuCacheService.getWithCache(
                    menuListCacheKey,
                    async () => {
                        const menusRes = await fetch(`${API_PROXY_BASE}/menu`, {
                            method: 'POST',
                            cache: 'no-store',
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${tokenData.token}`,
                            },
                            body: JSON.stringify({
                                token: tokenData.token,
                                organizationId: selected.id,
                                startRevision: 0,
                            }),
                        });
                        return await menusRes.json();
                    },
                    'menuList'
                );

                if (!menusData.externalMenus || menusData.externalMenus.length === 0) {
                    throw new Error('Нет доступных меню');
                }

                const orderedMenus = sortMenusByPreferredOrder(menusData.externalMenus);
                setOrganizations(orderedMenus);

                const urlCompany = getCompanyFromUrl();
                const savedCompany = localStorage.getItem('selectedCompany');

                let initialCompany;
                if (urlCompany) {
                    initialCompany = urlCompany;
                } else if (savedCompany && savedCompany !== 'All') {
                    initialCompany = savedCompany;
                } else {
                    initialCompany = orderedMenus[0]?.name || 'Aromiitaliani';
                }

                setSelectedCompany(initialCompany);
                localStorage.setItem('selectedCompany', initialCompany);

                const config = getPOSConfig(initialCompany);
                setPosConfig(config);

                const stripTrailingS = (s) => String(s || '').toLowerCase().replace(/s$/, '');
                const initialLower = String(initialCompany || '').toLowerCase();
                const initialMenu =
                    orderedMenus.find(menu => menu.name.toLowerCase() === initialLower) ||
                    orderedMenus.find(menu => stripTrailingS(menu.name) === stripTrailingS(initialCompany)) ||
                    orderedMenus.find(menu => menu.name.toLowerCase().includes(initialLower) || initialLower.includes(menu.name.toLowerCase())) ||
                    orderedMenus[0];
                fetchMenuById(initialMenu.id, selected.id, tokenData.token, initialCompany);

            } catch (error) {
                console.error('Ошибка при загрузке initialData:', error.message);
                setError('Ошибка при инициализации');
            } finally {
                setLoading(false);
            }
        };

        fetchInitialData();
    }, []);

    const fetchMenuById = async (externalMenuId, organizationId, token, companyName) => {
        try {
            setLoading(true);

            let disabledIds = new Set();
            let disabledItemIds = new Set();
            const isFastDelivery = isDeliveryMode();
            if (companyName) {
                const orgId = companyName.toLowerCase();
                if (isFastDelivery) {
                    setFdOnlyModifierIds(new Set());
                    try {
                        const [disRes, disItemsRes] = await Promise.all([
                            fetch(API_ENDPOINTS.disabledCategories.get(orgId, 'fd')),
                            fetch(API_ENDPOINTS.disabledItems.get(orgId, 'fd')),
                        ]);
                        const disData = await safeFetchJson(disRes);
                        const disItemsData = await safeFetchJson(disItemsRes);
                        disabledIds = new Set((disData.disabledCategories || []).map(d => d.category_id));
                        disabledItemIds = new Set((disItemsData.disabledItems || []).map(d => d.item_id));
                    } catch (e) {
                        console.error("Menu filters unavailable, showing unfiltered menu:", e);
                    }
                } else {
                    try {
                        const [disRes, disItemsRes, fdModRes] = await Promise.all([
                            fetch(API_ENDPOINTS.disabledCategories.get(orgId, 'es')),
                            fetch(API_ENDPOINTS.disabledItems.get(orgId, 'es')),
                            fetch(API_ENDPOINTS.fdOnlyModifiers.get(orgId)),
                        ]);
                        const disData = await safeFetchJson(disRes);
                        const disItemsData = await safeFetchJson(disItemsRes);
                        const fdModData = await safeFetchJson(fdModRes);
                        disabledIds = new Set((disData.disabledCategories || []).map(d => d.category_id));
                        disabledItemIds = new Set((disItemsData.disabledItems || []).map(d => d.item_id));
                        setFdOnlyModifierIds(new Set((fdModData.modifiers || []).map(m => m.modifier_id)));
                    } catch (e) {
                        console.error("Menu filters unavailable, showing unfiltered menu:", e);
                    }
                }
            }

            const menuCacheKey = menuCacheService.generateCacheKey('menu', organizationId, externalMenuId);
            const data = await menuCacheService.getWithCache(
                menuCacheKey,
                async () => {
                    const res = await fetch(`${API_PROXY_BASE}/menu/by_id`, {
                        method: 'POST',
                        cache: 'no-store',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            token,
                            organizationIds: [organizationId],
                            externalMenuId,
                            startRevision: 0,
                            version: 2,
                            asyncMode: false,
                        }),
                    });

                    if (!res.ok) {
                        throw new Error(`HTTP error! status: ${res.status}`);
                    }

                    return await res.json();
                },
                'menu'
            );

            processMenuData(data, disabledIds, disabledItemIds);

        } catch (err) {
            console.error("Ошибка в fetchMenuById:", err.message);
            setError("Не удалось загрузить меню");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!token || !selectedOrg || !selectedCompany || organizations.length === 0) {
            return;
        }

        const selectedMenu = organizations.find(menu =>
            menu.name.toLowerCase() === selectedCompany.toLowerCase() ||
            menu.name === selectedCompany
        ) || organizations[0];

        fetchMenuById(selectedMenu.id, selectedOrg.id, token, selectedCompany);
    }, [orderMode]);

    const processMenuData = (data, disabledIds = new Set(), disabledItemIds = new Set()) => {
        const itemCategories = data.itemCategories || [];

        const allProducts = itemCategories.flatMap(cat =>
            cat.items.map(item => {
                // Log both name and description to see what comes from Syrve
                if (item.name) {
                    console.log('Syrve product name:', {
                        name: item.name,
                        hasMultiLangName: item.name.includes('<en>') || item.name.includes('<ka>') || item.name.includes('<ru>')
                    });
                }
                if (item.description) {
                    console.log('Syrve product description:', {
                        name: item.name,
                        description: item.description,
                        hasMultiLangDesc: item.description.includes('<en>') || item.description.includes('<ka>') || item.description.includes('<ru>')
                    });
                }
                return {
                    ...item,
                    parentGroup: cat.id,
                    groupName: cat.name,
                };
            })
        );

        const filtered = allProducts.filter(product => {
            const price = product.itemSizes?.[0]?.prices?.[0]?.price;
            return price > 0 && !disabledItemIds.has(product.itemId);
        });

        const groups = itemCategories
            .filter(cat => filtered.some(p => p.parentGroup === cat.id))
            .filter(cat => !disabledIds.has(cat.id))
            .map(cat => ({
                id: cat.id,
                name: cat.name,
                order: 0,
            }));

        const orderedGroups = reorderPoshnoshGroups(groups, selectedCompany);

        setProducts(filtered);
        setGroups(orderedGroups);
        
        if (orderedGroups.length > 0) {
            const firstGroupId = orderedGroups[0].id;
            setSelectedGroupId(firstGroupId);
            setGroupProducts(filtered);
        } else {
            setGroupProducts([]);
            setSelectedGroupId(null);
        }
    };

    const loadGroups = async (organizationId) => {
        if (!token || !organizationId) return;

        try {
            setLoading(true);
            setError(null);
            setGroups([]);
            setGroupProducts([]);

            const groupsCacheKey = menuCacheService.generateCacheKey('groups', organizationId);
            const menuResponse = await menuCacheService.getWithCache(
                groupsCacheKey,
                async () => {
                    const menuRes = await fetch(`${API_PROXY_BASE}/menu`, {
                        method: 'POST',
                        cache: 'no-store',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            token,
                            organizationId: organizationId,
                            startRevision: 0
                        }),
                    });
                    return await menuRes.json();
                },
                'menu'
            );
            console.log('[STEP 1] Menu response:', menuResponse);

            const rawGroups = menuResponse.groups || [];
            const rawProducts = menuResponse.products || [];

            // Фильтрация продуктов по цене > 1
            const filteredProducts = rawProducts.filter(
                product => product.sizePrices?.[0]?.price?.currentPrice > 0
            );

            // Фильтрация групп: включена в меню и содержит хотя бы 1 продукт
            const activeGroups = rawGroups
                .filter(group => group.isIncludedInMenu)
                .filter(group =>
                    filteredProducts.some(product => product.parentGroup === group.id)
                )
                .sort((a, b) => a.order - b.order);

            const orderedActiveGroups = reorderPoshnoshGroups(activeGroups, selectedCompany);

            setGroups(orderedActiveGroups);
            setProducts(filteredProducts);
            
            if (orderedActiveGroups.length > 0 && !selectedGroupId) {
                const firstGroupId = orderedActiveGroups[0].id;
                setSelectedGroupId(firstGroupId);
                const filtered = filteredProducts.filter(product => product.parentGroup === firstGroupId);
                setGroupProducts(filtered);
            }
        } catch (err) {
            console.error('Ошибка при загрузке групп:', err);
            setError(err.message || 'Не удалось загрузить группы продуктов');
        } finally {
            setLoading(false);
        }
    };
    const handleGroupClick = (groupId) => {
        setSelectedGroupId(groupId);
        categorySectionRefs.current[groupId]?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    };

    useEffect(() => {
        if (!groups.length) return undefined;

        const observer = new IntersectionObserver(
            (entries) => {
                const visibleEntries = entries
                    .filter(entry => entry.isIntersecting)
                    .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

                const visibleGroupId = visibleEntries[0]?.target?.dataset?.groupId;
                if (visibleGroupId) {
                    setSelectedGroupId(visibleGroupId);
                }
            },
            {
                root: null,
                rootMargin: '-150px 0px -60% 0px',
                threshold: [0, 0.1, 0.25],
            }
        );

        groups.forEach(group => {
            const section = categorySectionRefs.current[group.id];
            if (section) observer.observe(section);
        });

        return () => observer.disconnect();
    }, [groups, products]);

    useEffect(() => {
        if (!selectedGroupId) return;

        categoryButtonRefs.current[selectedGroupId]?.scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
            block: 'nearest',
        });
    }, [selectedGroupId]);


    // Обработчик выбора организации



    useEffect(() => {
        const storedCart = JSON.parse(localStorage.getItem("cartByCompany")) || {};
        const storedQuantities = JSON.parse(localStorage.getItem("productQuantities")) || {};
        console.log('Корзина из localStorage:', storedCart);
        setCart(storedCart);
        setQuantities(storedQuantities);
    }, []);

    // Функция добавления товара в корзину
    const addToCart = (product, organizationId) => {
        if (!canOrder) return;

        const currentCart = { ...cart };

        if (!currentCart[organizationId]) {
            currentCart[organizationId] = [];
        }

        const productId = product.itemId;
        const existingProduct = currentCart[organizationId].find(p => p.id === productId);

        if (!existingProduct) {
            const transformedProduct = transformProductToCartItem(product, product.selectedModifiers);

            currentCart[organizationId].push(transformedProduct);
        }

        localStorage.setItem("cartByCompany", JSON.stringify(currentCart));
        setCart(currentCart);
    };

    const removeFromCart = (productId, organizationId) => {
        const currentCart = { ...cart };
        if (!currentCart[organizationId]) return;

        currentCart[organizationId] = currentCart[organizationId].filter(p => p.id !== productId);

        if (currentCart[organizationId].length === 0) {
            delete currentCart[organizationId];
        }

        localStorage.setItem("cartByCompany", JSON.stringify(currentCart));
        setCart(currentCart);
    };

    // Функция подсчета товаров в корзине
    const getCartCount = () => {
        return Object.values(cart).reduce((total, orgCart) => {
            return total + orgCart.reduce((sum, item) => sum + (item.quantity || 1), 0);
        }, 0);
    };
    const transformProductToCartItem = (product, selectedModifiers = []) => {
        const size = product.itemSizes?.[0] || {};
        const price = size.prices?.[0]?.price || 0;
        const imageUrl = size.buttonImageUrl || '';

        return {
            id: product.itemId,
            title: product.name || '',
            description: product.description || '',
            price: price,
            imageUrl: imageUrl,
            modifiers: selectedModifiers,
        };
    };
    const companyImages = {
        'copacabana': [copacabana1, copacabana2, copacabana3, copacabana4, copacabana5, copacabana6, copacabana7],
        'aromiitaliani': [aroma1, aroma2, aroma3, aroma4, aroma5, aroma6, aroma7, aroma8, aroma9, aroma10],
        'symposium': [symp1, symp2, symp3, symp4, symp5, symp6, symp7, symp8, symp9, symp10],
        poshnoshs: [posh1, posh2, posh3, posh4, posh5],
        nadimi: [nadimi1, nadimi2, nadimi3, nadimi4],
        cave: [cave1],
    };
    const companyDescriptions = {
        copacabana: "Copacabana is the place where the gastronomic cultures of Brazil and Japan meet and create the diverse tastes of fusion sushi, maki, cocktails and other specialties.",
        'aromiitaliani': "Aromi Italiani blends restaurant, cafe, pizzeria, and gelateria, offering Italian flavors, pizza, pasta, desserts, coffee, ice cream, croissants, and other delicacies on Europe Square.",
        'symposium': "Symposium is a wine lounge bar and shop with over 1000 wine labels from Georgia and 15 countries, offering meats, cheeses, and fruit boards. Our sommelier assists guests.",
        poshnoshs: "Posh Nosh offers street food from around the world, including fish and chips, burgers, falafel, and burritos, providing diverse flavors at an affordable price.",
        nadimi: "Nadimi is known for its exquisite dishes that blend traditional and modern culinary techniques, providing a unique dining experience with a diverse menu and excellent service.",
        cave: "Underground club specializing in high-quality live and electronic music and signature cocktail history in collaboration with Astoria products For collaboration message us on caveclubb@gmail.com",
    };
    const getCompanyAssetKey = (companyName = '') => {
        const key = companyName.toLowerCase();
        if (key === 'poshnosh' || key === 'poshnoshs') return 'poshnoshs';
        return key;
    };
    const calculateTotal = () => {
        return Object.entries(cart).reduce((total, [orgId, items]) => {
            const orgTotal = items.reduce((sum, item) => {
                const itemPrice = item.price * (item.quantity || 1);
                const modifiersPrice = item.modifiers?.reduce((modSum, mod) =>
                    modSum + (mod.price * (mod.quantity || 1)), 0) || 0;
                return sum + itemPrice + modifiersPrice;
            }, 0);
            return total + orgTotal;
        }, 0).toFixed(2);
    };
    const productSummaries = groupProducts.map((product) => ({
        id: product.itemId,
        name: product.name,
        description: product.description || 'No description',
    }));

    console.log("Список продуктов:", productSummaries);
    const { translations, locale } = useContext(LocalizationContext);
    const menuText = translations?.menu || {};

    const getTranslated = (id, field, fallback) => {
        // TESTING MODE - NO FALLBACKS
        if ((field === 'description' || field === 'name') && fallback) {
            console.log(`Parsing ${field}:`, {
                id,
                fallback,
                locale,
                hasLanguageTags: fallback.includes('<en>') || fallback.includes('<ka>') || fallback.includes('<ru>')
            });
            // Try to parse multi-language format from Syrve
            const parsedText = parseMultiLanguageDescription(fallback, locale);
            console.log(`Parsed ${field} result:`, parsedText || '[NO TRANSLATION FOUND]');
            return parsedText || fallback; // Show original if no translation
        }
        
        // For other fields, return original
        return fallback;
    };

    const normalizedSearchQuery = searchQuery.trim().toLowerCase();
    const filteredProducts = useMemo(() => {
        if (!normalizedSearchQuery) {
            return products;
        }

        return products.filter((product) => {
            const groupName = groups.find(group => group.id === product.parentGroup)?.name || '';
            const searchableText = [
                product.name,
                product.description,
                groupName,
            ].filter(Boolean).join(' ').toLowerCase();

            return searchableText.includes(normalizedSearchQuery);
        });
    }, [groups, normalizedSearchQuery, products]);

    const renderProductCard = (product) => {
        const orgId = selectedCompany;
        const inCart = cart[orgId]?.some((item) => item.id === product.itemId);
        const size = product.itemSizes?.[0];
        const price = size?.prices?.[0]?.price || 0;
        const imageUrl = size?.buttonImageUrl;

        return (
            <div key={product.itemId} className="product-card">
                <div className="menu_item_card_img">
                    {imageUrl ? (
                        <img
                            loading="lazy"
                            src={imageUrl}
                            className="product-image"
                            alt={product.name}
                            onClick={() => setSelectedProduct(product)}
                        />
                    ) : (
                        <div className="no-image">{menuText.NoImage || 'No image'}</div>
                    )}
                </div>

                <div className="product-info">
                    <div
                        className="product_title"
                        onClick={() => setSelectedProduct(product)}
                        style={{cursor: 'pointer'}}
                    >
                        {getTranslated(product.itemId, 'name', product.name)}
                    </div>

                    <div
                        className="product_description"
                        onClick={() => setSelectedProduct(product)}
                        style={{cursor: 'pointer'}}
                    >
                        {getTranslated(product.itemId, 'description', product.description || menuText['No description'] || 'No description')}
                    </div>

                    <div className="product-price">
                        <div className="product_price_text">
                            {price} <span className="price_lari">ლ</span>
                        </div>

                        {canOrder && (
                        <div
                            className="basket"
                            onClick={() => {
                                if (inCart) {
                                    removeFromCart(product.itemId, selectedCompany);
                                } else {
                                    setProductToModify(product);
                                }
                            }}
                            style={{cursor: 'pointer'}}
                        >
                            {inCart ? (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="iconsa icon-tabler icons-tabler-outline icon-tabler-basket"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M18 6l-12 12"></path>
                                    <path d="M6 6l12 12"></path>
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="icon icon-tabler icons-tabler-outline icon-tabler-basket"
                                >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path
                                        d="M5.001 8h13.999a2 2 0 0 1 1.977 2.304l-1.255 7.152a3 3 0 0 1-2.966 2.544h-9.512a3 3 0 0 1-2.965-2.544l-1.255-7.152a2 2 0 0 1 1.977-2.304z"></path>
                                    <path d="M17 10l-2-6"></path>
                                    <path d="M7 10l2-6"></path>
                                </svg>
                            )}
                        </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };
    const getDisplayName = (menuName) => {
        if (menuName === "Aromiitaliani") return "Aromi Italiani";
        if (menuName === "CopaCabana") return "Copacabana";
        if (menuName === "PoshNoshs") return "Poshnosh";
        return menuName;
    };
    const getCompanyFromUrl = () => {
        if (!company) return null;
        const companyLower = company.toLowerCase();

        if (companyLower === 'poshnosh') return 'PoshNoshs';
        if (companyLower === 'poshnoshs') return 'PoshNoshs';
        if (companyLower === 'aromiitaliani') return 'Aromiitaliani';
        if (companyLower === 'copacabana') return 'CopaCabana';
        if (companyLower === 'nadimi') return 'Nadimi';
        if (companyLower === 'symposium') return 'Symposium';
        if (companyLower === 'cave') return 'Cave';

        return null;
    };
    return (
        <div className="syrve-menu-container">


            {/* Состояние загрузки */}
            {loading && <div className="loading">{menuText.Loading || 'Loading...'}</div>}

            {/* Сообщение об ошибке */}
            {error && (
                <div className="error">
                    {menuText.Error || 'Error'}: {error}
                    <button onClick={() => setError(null)}>{menuText.Close || 'Close'}</button>
                </div>
            )}

            {/* Блок с организациями */}
            <div className="section">

                <div className="button-group">
                    {[
                        ...organizations,
                        ...COMING_SOON_MENUS.filter((comingSoonMenu) => (
                            !organizations.some((menu) => String(menu.name || '').toLowerCase() === String(comingSoonMenu.name || '').toLowerCase())
                        )),
                    ].map((menu) => {
                        let displayName = menu.name.replace(' Delivery', '');
                        if (menu.name === "Aromiitaliani") displayName = "Aromi Italiani";
                        if (menu.name === "CopaCabana") displayName = "Copacabana";
                        if (menu.name === "PoshNoshs") displayName = "Poshnosh";
                        const companyKey = getCompanyAssetKey(menu.name);
                        const buttonImage = companyImages[companyKey]?.[0];
                        const buttonBg = buttonImage || menu.bg;

                        return (
                            <button
                                key={menu.id}
                                className={`company-button ${selectedCompany === menu.name ? 'active' : ''} ${menu.comingSoon ? 'company-button--coming-soon' : ''}`}
                                style={buttonBg ? { '--company-button-image': `url(${buttonBg})` } : undefined}
                                disabled={menu.comingSoon}
                                onClick={() => {
                                    if (menu.comingSoon) return;
                                    const urlName = menu.name.toLowerCase();
                                    setSelectedCompany(menu.name);
                                    localStorage.setItem('selectedCompany', menu.name);

                                    const config = getPOSConfig(menu.name);
                                    setPosConfig(config);

                                    navigate(`/${urlName}`);
                                    fetchMenuById(menu.id, selectedOrg.id, token, menu.name);
                                }}
                            >
                                <span>{displayName}</span>
                                {menu.comingSoon && <span className="company-button-badge">{menuText.ComingSoon || 'Coming Soon'}</span>}
                            </button>
                        );
                    })}
                </div>
            </div>
            {selectedCompany && (
                <div className={`company_image ${getCompanyAssetKey(selectedCompany)}`}>

                    <Swiper pagination={true} modules={[Pagination]} className="company_slider">
                        {companyImages[getCompanyAssetKey(selectedCompany)]?.map((img, index) => (
                            <SwiperSlide key={index}>
                                <img src={img} alt={selectedCompany} className="company_slide_img"/>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <div className={"company_text_description"}>

                        <div className="company_text">
                            {getDisplayName(selectedCompany)}
                        </div>
                        <div className="company_description">
                            {companyDescriptions[getCompanyAssetKey(selectedCompany)]}
                        </div>
                    </div>
                </div>
            )}
            {isEuropeSquare && selectedCompany && (
                <div className="menu-view-only-notice" role="status">
                    {translations?.deliveryPage?.visitFastDelivery || 'Please visit fastdelivery.ge to place orders'}
                </div>
            )}
            {/* Блок с группами продуктов */}
            {selectedOrg && (
                <div className="section category-navigation-section">
                    <div className="menu-search-container">
                        <Search
                            className="menu-search-icon"
                            width="20"
                            height="20"
                            aria-hidden="true"
                        />
                        <input
                            className="menu-search-input"
                            type="search"
                            value={searchQuery}
                            onChange={(event) => setSearchQuery(event.target.value)}
                            placeholder={menuText.SearchMenu || 'Search menu'}
                            aria-label={menuText.SearchMenu || 'Search menu'}
                        />
                        {searchQuery && (
                            <button
                                type="button"
                                className="menu-search-clear"
                                onClick={() => setSearchQuery('')}
                                aria-label={menuText.ClearMenuSearch || 'Clear menu search'}
                            >
                                ×
                            </button>
                        )}
                        <button
                            type="button"
                            className="menu-search-action"
                            aria-label={menuText.MenuFilters || 'Menu filters'}
                            title={menuText.MenuFilters || 'Menu filters'}
                        >
                            <SlidersHorizontal size={22} aria-hidden="true" />
                        </button>
                    </div>
                    {groups.length > 0 ? (
                        <div className="button-group category-button-group">
                            {groups.map(group => (
                                <div key={group.id} className="group-info">
                                    <button
                                        ref={(element) => {
                                            categoryButtonRefs.current[group.id] = element;
                                        }}
                                        className={`group-button ${selectedGroupId === group.id ? 'active' : ''}`}
                                        onClick={() => handleGroupClick(group.id)}
                                    >
                                        {group.name}
                                    </button>

                                </div>
                            ))}
                        </div>
                    ) : (
                        !loading && <div className="no-groups"></div>
                    )}
                </div>

            )}
            {groups.length > 0 && products.length > 0 && (
                <div className={`products-section continuous-products-section${!canOrder && !isEuropeSquare ? ' products-section--view-only' : ''}`}>
                    <div className="menu-view-toolbar" aria-label={menuText.MenuViewSelector || 'Menu view selector'}>
                        <button
                            type="button"
                            className={`menu-view-button ${menuViewMode === 'grid' ? 'active' : ''}`}
                            onClick={() => setMenuViewMode('grid')}
                            aria-pressed={menuViewMode === 'grid'}
                            title={menuText.GridView || 'Grid view'}
                        >
                            <Grid2X2 size={20} aria-hidden="true" />
                            <span>{menuText.Grid || 'Grid'}</span>
                        </button>
                        <button
                            type="button"
                            className={`menu-view-button ${menuViewMode === 'list' ? 'active' : ''}`}
                            onClick={() => setMenuViewMode('list')}
                            aria-pressed={menuViewMode === 'list'}
                            title={menuText.ListView || 'List view'}
                        >
                            <List size={20} aria-hidden="true" />
                            <span>{menuText.List || 'List'}</span>
                        </button>
                    </div>
                    {groups.map((group) => {
                        const sectionProducts = filteredProducts.filter(product => product.parentGroup === group.id);

                        if (sectionProducts.length === 0) return null;

                        return (
                            <section
                                key={group.id}
                                ref={(element) => {
                                    categorySectionRefs.current[group.id] = element;
                                }}
                                className="category-product-section"
                                data-group-id={group.id}
                            >
                                <h2 className="category-section-title">{group.name}</h2>
                                <div className={`products-grid ${menuViewMode === 'list' ? 'products-list' : ''}`}>
                                    {sectionProducts.map(renderProductCard)}
                                </div>
                            </section>
                        );
                    })}
                </div>
            )}
            {groups.length > 0 && products.length > 0 && filteredProducts.length === 0 && (
                <div className="menu-search-empty">
                    {menuText.NoMenuItemsFound || 'No menu items found'}
                </div>
            )}


            {!canOrder && !isEuropeSquare && selectedCompany && (
                <div className="menu-delivery-cta-container">
                    <button
                        type="button"
                        className="menu-delivery-cta"
                        onClick={handleSwitchToDelivery}
                    >
                        {getCartCount() > 0 && (
                            <span className="cart-item-count">{getCartCount()}</span>
                        )}
                        <span className="cart-text">{menuText.SwitchToDelivery || 'Switch to Delivery'}</span>
                    </button>
                    <div className="menu-delivery-cta-hint">
                        {menuText.ViewOnlyMessage || 'Ordering is available for delivery only'}
                    </div>
                </div>
            )}

            {canOrder && getCartCount() > 0 && (
                <div
                    className="checkout-button-container"
                    onClick={() => handleXBarItemChange(0)}
                >
                    <button className="checkout-button">
            <span className="cart-item-count">
                {getCartCount()}
            </span>
                        <span className="cart-text">{menuText.ShowOrder || 'Show order'}</span>
                        <span className="cart-total-price">
                {calculateTotal()} ₾
            </span>
                    </button>
                </div>
            )}

            {canOrder && productToModify && (
                <ModifierModal
                    product={productToModify}
                    disabledModifierIds={fdOnlyModifierIds}
                    onClose={() => setProductToModify(null)}
                    onConfirm={(productWithMods) => {
                        addToCart(productWithMods, selectedCompany);
                        setProductToModify(null);
                    }}
                />
            )}
            {selectedProduct && (
                <ProductDetail
                    product={selectedProduct}
                    onClose={() => setSelectedProduct(null)}
                />
            )}
        </div>
    );
};

export default SyrveMenu;
